import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { CurrentResidenceQuery, SelectedAgencyQuery } from '../graphql/graphql';
import { useCurrentPath } from './useCurrentPath';
import { SCHEMA_CONTEXT, SchemaOrgType } from '../seo.constants';

export const useRealEstateAgentSchema = (
  data: CurrentResidenceQuery['residence'] | SelectedAgencyQuery['agency'],
  streetAddress: string | null | undefined,
  name?: string
) => {
  const { currPath } = useCurrentPath();
  const { t } = useTranslation();

  return useMemo(
    () => ({
      '@context': SCHEMA_CONTEXT,
      '@type': SchemaOrgType.RealEstateAgent,
      image: data?.logoUrl,
      description: data?.description,
      url: currPath,
      name: name || data?.name,
      address: {
        '@type': SchemaOrgType.PostalAddress,
        addressLocality: data?.city?.name,
        addressRegion: t('pages.current_item.country'),
        streetAddress,
        addressCountry: 'AZ'
      }
    }),
    [data, currPath, name, streetAddress]
  );
};
